import { render, staticRenderFns } from "./NanogenresTitleBrief.vue?vue&type=template&id=51ee144e&scoped=true&"
import script from "./NanogenresTitleBrief.vue?vue&type=script&lang=js&"
export * from "./NanogenresTitleBrief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ee144e",
  null
  
)

export default component.exports